export default "__VITE_ASSET__DU8d7M5D__"